import { AddNewSpecificationModal } from "molecules/Modals/AddNewSpecificationModal";
import React from "react";

import MasterTemplateTable from "templates/Master/MasterTemplateTable";
import api from "utils/api";
import SPECIFICATION_TYPES from "utils/specifications.constansts";

const Specification = () => {
  return (
    <MasterTemplateTable
      actions={{
        get: async () => {
          try {
            const { data } = await api("/specifications/get", {
              method: "get",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        create: async ({ name, type }) => {
          try {
            const reqData = { name, type };
            const { data } = await api("/specifications/add", {
              method: "post",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        update: async (id, { name, type }) => {
          try {
            const reqData = { name, type };
            const { data } = await api(`/specifications/update/${id}`, {
              method: "put",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        remove: async (id) => {
          try {
            const { data } = await api(`/specifications/delete/${id}`, {
              method: "delete",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
      }}
      pageHeading="Specifications"
      addRecord="Add Specification"
      searchRecord="Search Specification"
      table={{
        tableHeader: [
          {
            name: "Name",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Type",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Actions",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
        ],
        tableRowDatas: [
          {
            render: (record) => <td>{record?.name}</td>,
          },
          {
            render: (record) => (
              <td>
                {SPECIFICATION_TYPES?.find(
                  (type) => type?.value === record?.type
                )?.label || ""}
              </td>
            ),
          },
        ],
        actions: { editable: true, removable: true },
      }}
      actionModal={{
        title: "Specification",
        CustomModal: AddNewSpecificationModal,
      }}
    />
  );
};

export default Specification;
